import React, { FC } from 'react';
import moment from 'moment/moment';
import { EditCentsAssistConfigs } from './EditCentsAssistConfigs';

const COLUMNS = [
  { headerName: 'Customer Name', field: 'customerName', flex: 1 },
  { headerName: 'Customer Phone', field: 'customerPhone', flex: 1 },
  { headerName: 'Hours and Locations', field: 'hoursAndLocations', flex: 1 },
  { headerName: 'Services and Prices', field: 'servicesAndPrices', flex: 1 },
  { headerName: 'New Order Flow', field: 'newOrder', flex: 1 },
  { headerName: 'Existing Order Flow', field: 'existingOrder', flex: 1 },
  { headerName: 'Attendent Flow', field: 'attendent', flex: 1 },
  {
    headerName: 'Start Date/Time',
    type: 'dateTime',
    field: 'startDateTime',
    flex: 2,
    valueFormatter: (params) => {
      return moment(params.value).format('MM-D-YYYY h:mm A');
    },
  },
  { headerName: 'Call Duration', field: 'callDuration', flex: 1 },
  { headerName: 'Call Summary', field: 'callSummary', flex: 2 },
  { headerName: 'Transcript', field: 'transcript', flex: 1 },
  { headerName: 'Recording URL', field: 'recording_url', flex: 1 },
  { headerName: 'Call Reason', field: 'call_reason', flex: 1 },
  { headerName: 'Transfer Reason', field: 'transfer_reason', flex: 1 },
  { headerName: 'User Sentiment', field: 'user_sentiment', flex: 1 },
];

export const CentsAssist: FC<{
  businessId: number;
}> = ({ businessId }) => {
  return (
    <div className="page-container">
      <EditCentsAssistConfigs businessId={businessId} />
    </div>
  );
};
